<div class="bulb-private-share-link">
  <div>
    <h2 ng-if="permissionSelectCtrl.pageViewSharePanel" class="hr-title" transloco="shareLink.title"></h2>
    <div class="bulb-share-permission">
      <div class="bulb-shared-link">
        <input class="bulb-page-name"
              name="shareableLink"
              id="shareableLink"
              type="text"
              readonly
              [ngModel]="shareUrl"
        >
        <div class="bulb-share-link-copied-text">
          <span class="bulb-share-link-copied-text__text"
                [ngClass]="{'bulb-share-link-copied-text__text--show-copy-text' : addShowCopyClass}"
                transloco="shareLink.copyText">
                Copied to Clipboard
          </span>
        </div>
      </div>

      <div class="bulb-private-share-link-btns">
        <button
              class="bulb-copy-button"
              type="button"
              (click)="copyShareableLink()"
              aria-labelledby="shareable-link"
        >
          <svg-icon
            [key]="buttonIcons.copyIcon"
            class="private-link-copy-icon"
            fontSize="1.5em"
          ></svg-icon>
        </button>
        <button
          class="bulb-break-link-button"
          type="button"
          (click)="createNewLinkModal()"
        >
          <svg-icon
            [key]="buttonIcons.unlinkIcon"
            fontSize="1.5em"
          ></svg-icon>
        </button>
      </div>
    </div>
  </div>
</div>
